import { listSupplierBillVatBySupplierNamePopUp } from "api/supplierBillVat"; 
import useAPI from "hooks/useAPI";
import { useCallback, useEffect, useState } from 'react'

const useListSupplierBillVatPopUp = ({ currentPageNumber, pageSize }) => {
    const [searchName, setSearchName] = useState(undefined)
    const {
        makeRequest: listSupplierBillVatPopUp,
        data: listSupplierBillVatPopUpData,
        loading: isLoadingListSupplierBillVatPopUp,
        pagination: listSupplierBillVatPopUpPagination,
    } = useAPI()

    const onSearchName = useCallback(({ searchName }) => {
        setSearchName(searchName)
    }, [])

    useEffect(() => {
        listSupplierBillVatPopUp(() =>
        listSupplierBillVatBySupplierNamePopUp({
            page: currentPageNumber,
            pageSize,
            name: searchName,
        })
        )
    }, [listSupplierBillVatPopUp, searchName, currentPageNumber, pageSize])

    return {
        listSupplierBillVatPopUpData,
        isLoadingListSupplierBillVatPopUp,
        listSupplierBillVatPopUpPagination,
        onSearchName,
    }
}

export default useListSupplierBillVatPopUp